// Notification Service for in-CRM notifications
import api from './api';

class NotificationService {
  constructor() {
    this.notifications = [];
    this.listeners = [];
  }

  // Get all notifications for current user
  async getNotifications() {
    try {
      const response = await api.get('/notifications');
      this.notifications = response.data;
      this.notifyListeners();
      return response.data;
    } catch (error) {
      console.error('Error fetching notifications:', error);
      return [];
    }
  }

  // Mark notification as read
  async markAsRead(notificationId) {
    try {
      await api.put(`/notifications/${notificationId}/read`);
      this.notifications = this.notifications.map(n => 
        n.id === notificationId ? { ...n, read: true } : n
      );
      this.notifyListeners();
    } catch (error) {
      console.error('Error marking notification as read:', error);
    }
  }

  // Mark all notifications as read
  async markAllAsRead() {
    try {
      await api.put('/notifications/mark-all-read');
      this.notifications = this.notifications.map(n => ({ ...n, read: true }));
      this.notifyListeners();
    } catch (error) {
      console.error('Error marking all notifications as read:', error);
    }
  }

  // Get unread count
  getUnreadCount() {
    return this.notifications.filter(n => !n.read).length;
  }

  // Subscribe to notification updates
  subscribe(callback) {
    this.listeners.push(callback);
    return () => {
      this.listeners = this.listeners.filter(l => l !== callback);
    };
  }

  // Notify all listeners of changes
  notifyListeners() {
    this.listeners.forEach(callback => callback(this.notifications));
  }

  // Add a new notification (for real-time updates)
  addNotification(notification) {
    this.notifications.unshift(notification);
    this.notifyListeners();
  }
}

export default new NotificationService();
